import React, { useEffect } from 'react';
import { Flame, Droplets, Mountain, Wind, X, Trophy } from 'lucide-react';

export const BadgeNotification = ({ badge, onClose }) => {
    // Auto-dismiss after 5 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 5000);
        return () => clearTimeout(timer);
    }, [onClose]);

    if (!badge) return null;

    const getIcon = (element) => {
        switch(element) {
            case 'fire': return <Flame className="w-6 h-6 text-orange-500 animate-bounce" />;
            case 'water': return <Droplets className="w-6 h-6 text-blue-400 animate-bounce" />;
            case 'earth': return <Mountain className="w-6 h-6 text-emerald-400 animate-bounce" />;
            case 'air': return <Wind className="w-6 h-6 text-cyan-400 animate-bounce" />;
            default: return <Trophy className="w-6 h-6 text-yellow-400 animate-bounce" />;
        }
    };

    const getBorderColor = (element) => {
        switch(element) {
            case 'fire': return "border-orange-500";
            case 'water': return "border-blue-500";
            case 'earth': return "border-emerald-500";
            case 'air': return "border-cyan-500";
            default: return "border-slate-500";
        }
    };

    const getBgGradient = (element) => {
        switch(element) {
            case 'fire': return "from-orange-900/90 to-slate-900/95";
            case 'water': return "from-blue-900/90 to-slate-900/95";
            case 'earth': return "from-emerald-900/90 to-slate-900/95";
            case 'air': return "from-cyan-900/90 to-slate-900/95";
            default: return "from-slate-800 to-slate-900";
        }
    };

    return (
        <div className="fixed bottom-8 right-4 md:right-8 z-[100] animate-slide-up">
            <div className={`relative flex items-center gap-4 p-4 pr-10 rounded-xl border-l-4 shadow-2xl backdrop-blur-md bg-gradient-to-r text-white ${getBorderColor(badge.icon)} ${getBgGradient(badge.icon)}`}>
                
                {/* Glow Effect */}
                <div className="absolute inset-0 bg-white/5 rounded-xl animate-pulse"></div>

                {/* Icon Container */}
                <div className="p-2 bg-slate-950/50 rounded-full border border-white/10 relative z-10">
                    {getIcon(badge.icon)}
                </div>

                {/* Text Content */}
                <div className="relative z-10">
                    <p className="text-[10px] font-bold uppercase tracking-widest opacity-80 mb-0.5">Achievement Unlocked</p>
                    <h4 className="text-lg font-bold leading-tight">{badge.name}</h4>
                    <p className="text-xs text-slate-300 mt-1">{badge.desc}</p>
                </div>

                {/* Close Button */}
                <button 
                    onClick={onClose} 
                    className="absolute top-2 right-2 text-slate-400 hover:text-white p-1 rounded-full hover:bg-white/10 transition-colors z-20"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};